import {
  FAIL_GET_JERSEYS,
  REQUEST_GET_JERSEYS,
  SUCCESS_GET_JERSEYS,
} from '../../../actions/entities/jerseys';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  return {
    ...state,
    data: action.list,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_JERSEYS]: requestFetch,
  [SUCCESS_GET_JERSEYS]: successFetch,
  [FAIL_GET_JERSEYS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/jerseys/list.js